export default "__VITE_ASSET__CW9cLMoL__"